<div *ngIf="formField?.errors?.required && formField.touched" class="invalid-feedback">
  <ng-container *ngIf="formField?.errors?.required">
    <div *ngFor="let m of messages">
      {{ m }}
    </div>
  </ng-container>
</div>
<div *ngIf="formField?.errors?.email && formField.touched" class="invalid-feedback">
    <span *ngIf="formField?.errors?.email">
      This field must be a valid email.
    </span>
</div>
<div *ngIf="formField?.errors?.pattern && formField.touched" class="invalid-feedback">
    <span *ngIf="messages[0] === defaultMessage">
      This field must be a valid character.
    </span>
  <span *ngIf="messages[0] !== defaultMessage">
      {{ messages }}
    </span>
</div>
<div *ngIf="formField?.errors?.max && formField.touched" class="invalid-feedback">
    <span *ngIf="messages[0] === defaultMessage">
      Maximum number is 99.
    </span>
  <span *ngIf="messages[0] !== defaultMessage">
      {{ messages }}
    </span>
</div>
<div *ngIf="formField?.errors?.min && formField.touched" class="invalid-feedback">
    <span *ngIf="messages[0] === defaultMessage">
      Minimum number is 0.
    </span>
  <span *ngIf="messages[0] !== defaultMessage">
      {{ messages }}
    </span>
</div>

<div *ngIf="formField?.errors?.maxlength && formField.touched" class="invalid-feedback">
  <span *ngIf="messages[0] === defaultMessage">
    Maximum allowed length is {{ formField.errors.maxlength.requiredLength }} characters.
  </span>
  <span *ngIf="messages[0] !== defaultMessage">
    {{ messages }}
  </span>
</div>

<div *ngIf="formField?.errors?.forbiddenChars && formField.touched" class="invalid-feedback">
  <span *ngIf="messages[0] === defaultMessage">
  Special characters (&lt; &gt; &amp; # ! &quot; &#39; % * / \ | ( ) {{ '{' }} {{ '}' }} ~ ^ @ + = ; : , ?) are not allowed.
  </span>
  <span *ngIf="messages[0] !== defaultMessage">
    {{ messages }}
  </span>
</div>

<div *ngIf="formField?.errors?.invalidStoreName && formField.touched" class="invalid-feedback">
  <span *ngIf="messages[0] === defaultMessage">
    Only alphabets, numbers, and spaces are allowed.
  </span>
  <span *ngIf="messages[0] !== defaultMessage">
    {{ messages }}
  </span>
</div>

